export const SET_SNACKBAR = 'SET_SNACKBAR';
export const REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION';
export const ADD_NOTIFICATION = 'ADD_NOTIFICATION';
export const REMOVE_STATIC_NOTIFICATION = 'REMOVE_STATIC_NOTIFICATION';
export const ADD_STATIC_NOTIFICATION = 'ADD_STATIC_NOTIFICATION';